export default function SectionHeader({ eyebrow, title, description, align = "left", accentTitle, testId }) {
  return (
    <div
      className={`${align === "center" ? "mx-auto text-center max-w-3xl" : "max-w-3xl"} mb-12 md:mb-16`}
      data-testid={testId}
    >
      {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
      <h2 className="text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.1] tracking-tight text-slate-900">
        {title}{" "}
        {accentTitle && (
          <span className="font-serif-display italic font-normal text-[var(--brand-blue)]">{accentTitle}</span>
        )}
      </h2>
      {description && (
        <p className="mt-5 text-lg md:text-xl text-slate-600 leading-relaxed">{description}</p>
      )}
    </div>
  );
}
